/**
 * domainRouter.ts
 * 
 * Lógica para identificar em qual domínio/ambiente a aplicação está rodando.
 * Utilizado para chavear entre @app (Mobile) e @manager (Web Management).
 */

export enum AppDomain {
  MOBILE = 'mobile',
  MANAGER = 'manager',
  REGISTRATION = 'registration'
}

export const getAppDomain = (): AppDomain => {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  const hash = window.location.hash.toLowerCase();
  
  // Detecção de subdomínio: cadastro.wastebank.com.br (ou qualquer host com "cadastro"/"registration")
  if (hostname.includes('cadastro') || hostname.includes('registration')) {
    return AppDomain.REGISTRATION;
  }
  
  // Detecção por hash (#cadastro, #/cadastro, #registration)
  if (hash.includes('cadastro') || hash.includes('registration')) {
    return AppDomain.REGISTRATION;
  }
  if (hash.includes('manager') || hash.includes('admin')) {
    return AppDomain.MANAGER;
  }
  if (hash.includes('app') || hash.includes('mobile')) {
    return AppDomain.MOBILE;
  }
  
  // Exemplo de lógica de domínio:
  // manager.seudominio.com -> MANAGER
  // app.seudominio.com -> MOBILE
  if (hostname.includes('manager')) {
    return AppDomain.MANAGER;
  }
  
  // Fallback por rota/caminho URL
  if (pathname.startsWith('/cadastro') || pathname.startsWith('/registration')) {
    return AppDomain.REGISTRATION;
  }
  
  // Fallback ou detecção por query parameter para desenvolvimento/testes
  const urlParams = new URLSearchParams(window.location.search);
  const domainParam = urlParams.get('domain');
  
  if (domainParam === 'cadastro' || domainParam === 'registration') {
    return AppDomain.REGISTRATION;
  }

  if (domainParam === 'manager') {
    return AppDomain.MANAGER;
  }
  
  if (domainParam === 'app' || domainParam === 'mobile') {
    return AppDomain.MOBILE;
  }

  // Padrão do projeto atual: Se não houver domínio específico, 
  // o App.tsx original já lidava com os dois. 
  return AppDomain.MOBILE;
};
